import TableRequests from './TableRequests'
import getServiceRequests from '../api/getServiceRequests'
import { router } from '~/router'
import * as R from 'ramda'
import FormServiceRequestsFilter from './FormServiceRequestsFilter'

const paginationParams = ['page', 'paginate']

const { parseInt: toNumber } = Number
const notEmpty = R.compose(R.not, R.isEmpty)
const notNil = R.compose(R.not, R.isNil)
const notNempty = R.allPass([notEmpty, notNil])
const pickNotNempty = R.pickBy(notNempty)
const pickPaginationParams = R.pick(paginationParams)
const omitPaginationParams = R.omit(paginationParams)

const defaultToNumber = R.useWith(R.defaultTo, [R.identity, toNumber])

const safeObj = R.pipe(
	R.juxt([R.keys, R.values]),
	R.apply(R.zipObj),
)

const overPageDefaultTo = (number) => R.over(
	R.lensProp('page'),
	defaultToNumber(number)
)
const overPaginateDefaultTo = (number) => R.over(
	R.lensProp('paginate'),
	defaultToNumber(number)
)

const parsePaginationParams = R.pipe(
	pickPaginationParams,
	overPageDefaultTo(1),
	overPaginateDefaultTo(30),
)

const ServiceRequests = {
	name: 'ServiceRequests',
	router,
	data: vm => ({
		requests: [],
		loading: false,
		params: {
			pagination: parsePaginationParams(vm.$route.query),
			filter: omitPaginationParams(vm.$route.query),
		},
		total: null,
	}),
	computed: {
		combinedParams: function() {
			return R.mergeRight(this.params.pagination, this.params.filter)
		},
		safeFilter: function() {
			return safeObj(this.params.filter)
		},
		safePagination: function() {
			return safeObj(this.params.pagination)
		},
	},
	mounted() {
		let scrollIntoView = false;

		const fetchData = async () => {
			this.loading = true

			return getServiceRequests(
				this.combinedParams
			).then(({ items, total }) => {
				this.requests = items
				this.total = total
				this.loading = false

				if (!scrollIntoView) return;

				this.$nextTick(() => {
					this.$refs.table.scrollIntoView({ behavior: 'smooth', block: 'start' })
					scrollIntoView = false
				})
			})
		}

		this.$watch('params', fetchData, { deep: true })

		this.$router.afterEach(({ query }) => {
			scrollIntoView = true
			this.params = {
				pagination: parsePaginationParams(query),
				filter: omitPaginationParams(query)
			}
		})

		this.$on('update', (query) => {
			this.$router.push({ query: pickNotNempty(query) })
		})

		fetchData()
	},
	render() {
		return (
			<div>
				<FormServiceRequestsFilter
					class="service-requests-form"
					initialValues={ this.safeFilter }
					onFinish={ newFilter => this.$emit('update', {
						page: 1,
						paginate: this.safePagination.paginate,
						...newFilter,
					}) }
				/>
				<TableRequests
					ref="table"
					dataSource={ this.requests }
					loading={ this.loading }
					pagination={{
						onChange: (page, paginate) => this.$emit('update', {
							page,
							paginate,
							...this.safeFilter,
						}),
						total: this.total,
						pageSize: this.safePagination.paginate,
						current: this.safePagination.page,
						sortArray: [30, 60, 90],
					}}
				/>
			</div>
		)
	},
}

export default ServiceRequests
